"use client"

import { BarChart3, Shield, Users, FileText, Activity, TrendingUp } from "lucide-react"
import { usePathname } from "next/navigation"
import Link from "next/link"
import { cn } from "@/lib/utils"

export function AdminSidebar() {
  const pathname = usePathname()

  const menuItems = [
    {
      title: "Dashboard",
      icon: BarChart3,
      href: "/dashboard/admin",
    },
    {
      title: "HR Management",
      icon: Users,
      href: "/dashboard/admin/hr-management",
    },
    {
      title: "Interview Results",
      icon: FileText,
      href: "/dashboard/admin/interview-results",
    },
    // The cross-platform tracking portal ("Interviews" + "B2B → B2C Conversion")
    // moved OFF the customer app to the internal admin.aiinterviewagents.com
    // subdomain (Basic-Auth gated). See admin-portal/.
    // {
    //   title: "Analytics & Metrics",
    //   icon: TrendingUp,
    //   href: "/dashboard/admin/analytics",
    // },
    // {
    //   title: "Activity Tracking",
    //   icon: Activity,
    //   href: "/dashboard/admin/activity-tracking",
    // },
  ]

  return (
    <div className="w-64 h-full bg-white border-r flex flex-col">
      <div className="flex items-center gap-3 p-6 border-b h-16">
        <Link href={"/dashboard/agency"} className="flex items-center space-x-2">

          <div className="flex items-center justify-center">
            <img src={"/logo2.png"} alt="logo" className="w-5" />
          </div>
          <span className="text-xl font-bold text-[#1c3038] dark:text-white">
            AI Interview Agents
          </span>
        </Link>
      </div>

      {/* Navigation */}
      <div className="flex-1 overflow-auto py-4 px-3">
        <nav className="space-y-1">
          {menuItems.map((item) => (
            <Link
              key={item.title}
              href={item.href}
              className={cn(
                "flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors",
                pathname === item.href
                  ? "bg-blue-50 text-blue-600"
                  : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"

              )}
            >
              <item.icon className={cn("h-5 w-5", pathname === item.href ? "text-blue-600" : "text-gray-500"
              )} />
              <span>{item.title}</span>
            </Link>
          ))}
        </nav>
      </div>


    </div>
  )
}
